import {Mapper} from '@s-ui/domain'

export class FromRawDataToLoanCalculationEntityObjectTransactionsMapper extends Mapper {
  constructor({config, loanCalculationsB2CTransactionsEntity}) {
    super()

    this._loanCalculationsB2CTransactionsEntity = loanCalculationsB2CTransactionsEntity
    const {
      CAIXA,
      COFIDIS,
      LENDROCK,
      MOBILIZE,
      SANTANDER,
      SANTANDER_PRI,
      SANTANDER_WITH_CASUALTY_INSURANCE,
      STELLANTIS,
      SANTANDER_WITHOUT_INSURANCE,
      VWFS
    } = config.get('financing').FINANCING_PARTNERS

    const {CASUALTY, NO_INSURANCE} = config.get('financing').INSURANCE_IDS
    this._caixa = CAIXA
    this._cofidis = COFIDIS
    this._lendrock = LENDROCK
    this._mobilize = MOBILIZE
    this._santander = SANTANDER
    this._santanderPri = SANTANDER_PRI
    this._santanderWithCasualtyInsurance = SANTANDER_WITH_CASUALTY_INSURANCE
    this._stellantis = STELLANTIS
    this._casualtyInsuranceId = CASUALTY
    this._santanderWithoutInsurance = SANTANDER_WITHOUT_INSURANCE
    this._noInsuranceId = NO_INSURANCE
    this._vwfs = VWFS
  }

  getLenderLegalTextId = (insuranceId, lender) => {
    switch (`${insuranceId}/${lender}`) {
      case `${this._casualtyInsuranceId}/${this._santander}`:
        return this._santanderWithCasualtyInsurance
      case `${this._noInsuranceId}/${this._santander}`:
        return this._santanderWithoutInsurance
      default:
        switch (lender) {
          case this._santander:
          case this._santanderPri:
          case this._caixa:
          case this._cofidis:
          case this._lendrock:
          case this._mobilize:
          case this._stellantis:
          case this._vwfs:
            return lender
          default:
            return null
        }
    }
  }

  map = rawData => {
    const tempObj = {}

    for (let i = 0; i < rawData.length; i++) {
      const fareData = rawData[i]
      const {insuranceId, lender} = fareData
      if (!insuranceId || !lender) return null
      const lenderLegalTextId = this.getLenderLegalTextId(insuranceId, lender)
      const objKey = insuranceId === this._noInsuranceId ? 'withoutInsurance' : 'withInsurance'
      tempObj[objKey] = {...fareData, lenderLegalTextId}
    }

    return this._loanCalculationsB2CTransactionsEntity(tempObj)
  }
}
